import type { ReactNode } from "react"

import { SIDEBAR_GLYPH_SLOT_CLASS } from "@/components/sidebar/sidebar-constants"
import { cn } from "@/lib/utils"

/** 32px column wrapper so sidebar glyphs share one vertical line. */
export function SidebarGlyphSlot({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <span data-sidebar="glyph-slot" className={cn(SIDEBAR_GLYPH_SLOT_CLASS, className)}>
      {children}
    </span>
  )
}
